/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedSoldHeader_item$ref = any;
export type PdpRespSimilarItemsLanding_item$ref = any;
export type PdpRespSimilarItemsLanding_item = {
    readonly title: string | null;
    readonly isSold: boolean | null;
    readonly isListingNotListed: boolean | null;
    readonly isListingUnlisted: boolean | null;
    readonly seller: {
        readonly isInternal: boolean | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedSoldHeader_item$ref;
    readonly " $refType": PdpRespSimilarItemsLanding_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsLanding_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSold",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isListingNotListed",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isListingUnlisted",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isInternal",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedSoldHeader_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '29d995be5fdc5a72548423fbf781ed77';
export default node;
